import { render, staticRenderFns } from "./RoomStatusCard.vue?vue&type=template&id=9a2feb28"
import script from "./RoomStatusCard.vue?vue&type=script&lang=js"
export * from "./RoomStatusCard.vue?vue&type=script&lang=js"
import style0 from "./RoomStatusCard.vue?vue&type=style&index=0&id=9a2feb28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports